import React from 'react'
import Helmet from 'react-helmet'

const SiteMeta = ({ title, isRoot = false, url = 'top' }) => (
  <Helmet
    title={title}
    meta={[
      {
        name: 'viewport',
        content: 'width=device-width,initial-scale=1',
      },
      {
        name: 'format-detection',
        content: 'email=no,telephone=no,address=no',
      },
      {
        name: 'msapplication-TileImage',
        content: 'https://s3.ap-northeast-1.amazonaws.com/akasixi-portfolio/akashi2.jpg?response-content-disposition=inline&X-Amz-Security-Token=AgoGb3JpZ2luEL3%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDmFwLW5vcnRoZWFzdC0xIoACEgT%2Fptt49RsDNjjy0HDiM7P2d5K32JDfpz%2BsCoAV8Yn%2FAWpBBfE55iDMPijLn9N4u28cv1ytsYDjTylm4M3ZyJyLIcF2D7CFqGU7c5XLe74PU%2FD1gqMwHydQ7VaIqxQCV0hlCUdzQDc%2FNdft1xD9TvE%2FQRa%2FeFzMwwupUj%2FjC%2Fb9B7SFAmzvdh2iECgUDKF0O7aJWXi3%2BcwKmoHTP7agp9tp1VUzWK8hT44EqF0EW5ziTDARB3vjht%2BsK3rkjegz9Ke1RwTqSAUAbE2kEQv4mG7K7Ub%2BbNizuMrUe6tg9BJZflHAlaQ7eB0GQtf6Ofnjtjcgw6WYm84IVDh2ohT0cSrbAwhzEAAaDDk0NDA2MDU4OTkwNCIMNuaRewD8FHnh59ERKrgDkbUvXxDYtkTeRaf%2FpYka26BKkBj4KMfuATh%2BmRCMAd8XtuWcZ9lLD6Us9%2BxZ50pGWv7Op3liIM4s8MKP8ho3NZ1lMXpyABrg37xOMybgnzrNVe0S0vik3deIr1TNz1EJsKp0q9p8hQEhv%2B7qDlVmju%2FysHy9CwB7QEzBUcuOl5%2BkN1UJDeSEaaBAS10dfKITfg%2BnngdafPmH7f3ujyfseaetBDQpoaDHpPhNBuTFlUyWCd3k5O8Kq6jbHk5scYEkqfm%2F%2BIuRG1%2BbhSaSPixVnaxjERjp3O%2BQBXJ65oufdZH%2Ban5TPpTDZTuH90%2FC2bRQfW%2BD1tlPURSlahSpmWYfbb7ryhGZkBiYOCmjXscbQtIZhSGO8LkAgN9dVzN77DuEnUUw32EHRUlIHS38oiXHihoFk6n8%2BTz7WXw9tc1ujzQYGHYNGkPRrFZJXX1k%2FD5i2nAs7QRxNBDAddHAMroq6vzycRbQQKQv5hN5tze%2FgCsNT1XBn9Odnsc49cCcQlaQ%2Fqw46SIY3PaWP9jPJmUvOV0vYNI8y4yTfHpivyJCRRw1XxX5bLdbtJJPLXKSk3u4y%2BdUJBTa53IwmOuJ5wU%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20190520T093908Z&X-Amz-SignedHeaders=host&X-Amz-Expires=300&X-Amz-Credential=ASIA5XTTFM5IEUKLV3NP%2F20190520%2Fap-northeast-1%2Fs3%2Faws4_request&X-Amz-Signature=bef485cde72a7c96af00339213bebb53a8589461aa8b3a03cb4a7033bf1d76ce',
      },
      {
        property: 'og:title',
        content: title,
      },
      {
        property: 'og:type',
        content: isRoot ? 'website' : 'article',
      },
      {
        property: 'og:url',
        content: url,
      },
      {
        name: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        name: 'twitter:site',
        content: '@akashi__akashi',
      },
    ]}
  />  
)

export default SiteMeta;
